<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <template slot-scope="props" slot="links">
        <sidebar-item :link="{name: 'Dashboard', icon: 'nc-icon nc-chart-pie-35', path: '/admin/overview'}"></sidebar-item>
        <sidebar-item :link="{name: 'Analysis', icon: 'nc-icon nc-chart-bar-32', path: '/admin/analysis'}"></sidebar-item>
        <sidebar-item :link="{name: 'Alerts', icon: 'nc-icon nc-bulb-63', path: '/admin/alerts'}"></sidebar-item>
        <sidebar-item :link="{name: 'Reports', icon: 'nc-icon nc-single-copy-04', path: '/admin/reports'}"></sidebar-item>
        <sidebar-item :link="{name: 'Organization', icon: 'nc-icon nc-settings-tool-66', path: '/admin/organization'}"></sidebar-item>
        <sidebar-item :link="{name: 'Resources', icon: 'nc-icon nc-notes', path: '/admin/resources'}"></sidebar-item>
        <sidebar-item :link="{name: 'Support', icon: 'nc-icon nc-email-83', path: '/admin/support'}"></sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>

      <content-footer></content-footer>
    </div>

    <portal-target name="modal"></portal-target>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import UserMenu from './Extra/UserMenu.vue'
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      UserMenu
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      initScrollbar() {
        let docClasses = document.body.classList;
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          // if we are on windows OS we activate the perfectScrollbar function
          initScrollbar('main-panel');

          docClasses.add('perfect-scrollbar-on');
        } else {
          docClasses.add('perfect-scrollbar-off');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  }

</script>
